import { environment } from '../environments/environment';

export function featureFlagEnabled(id: string) {
  return environment.featureFlags.find((x) => x.id === id)?.enabled;
}
